module.exports = __webpack_public_path__ + "Roboto-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Medium.woff
// module id = 95
// module chunks = 0